
import {
    GET_ADMIN_STATS_SUCCESS,
    GET_ADMIN_STATS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    stats: {},
    recentActivities: [],
    growthData: [],
    error: {},
}

const dashboardAdmin = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ADMIN_STATS_SUCCESS:
            return {
                ...state,
                stats: action.payload.stats,
                recentActivities: action.payload.recent_activities,
                growthData: action.payload.growth_data,
            }

        case GET_ADMIN_STATS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default dashboardAdmin
